import { Component, Input } from '@angular/core';
import { LibraryPage, ReportConfig } from '@modules/report-generator/interfaces';

interface PageSection {
  slug: string;
  name: string;
  pages: LibraryPage[];
  isExpanded: boolean;
}

@Component({
  selector: 'app-page-library',
  templateUrl: './page-library.component.html',
  styleUrls: ['./page-library.component.scss']
})
export class PageLibraryComponent {
  @Input() pageLibrary?: LibraryPage[] | null = [];
  @Input() reportConfig?: ReportConfig | null;

  sections: PageSection[] = [];

  ngOnInit(): void {
    this.groupPagesBySection();
  }
  
  ngOnChanges(): void {
    this.groupPagesBySection();
  }

  onDragStart(event: DragEvent, page: LibraryPage): void {
    if (event.dataTransfer) {
      event.dataTransfer.setData('application/json', JSON.stringify(page));
      event.dataTransfer.effectAllowed = 'copy';
    }
  }

  getThumbnailAspectRatio(page: LibraryPage): string {
    return page.orientation === 'landscape' ? '842/595' : '595/842';
  }

  getThumbnailMaxWidth(page: LibraryPage): string {
    return page.orientation === 'landscape' ? '170px' : '120px';
  }

  toggleSection(section: PageSection): void {
    const wasExpanded = section.isExpanded;

    // Collapse all sections
    this.sections.forEach(s => s.isExpanded = false);
    
    // If the clicked section was collapsed, expand it
    // If it was expanded, leave all collapsed
    if (!wasExpanded) {
      section.isExpanded = true;
    }
  }

  showSection(sectionName: string): boolean {
    const test = this.reportConfig?.test as Record<string, any>;
    if (!test) {
      return true
    }
    
    if (test.is_ppd && sectionName.includes("(Lactate)")) {
      return false;
    } else if (test.is_lactate && sectionName.includes("(PPD)")) {
      return false;
    }

    return true;
  }

  private groupPagesBySection(): void {
    // Group pages by section_slug
    const sectionMap = new Map<string, LibraryPage[]>();
    
    (this.pageLibrary ?? []).forEach(page => {
      const sectionName = page.section_name;
      if (!sectionMap.has(sectionName)) {
        sectionMap.set(sectionName, []);
      }
      sectionMap.get(sectionName)!.push(page);
    });
    
    // Convert to PageSection array
    this.sections = Array.from(sectionMap.entries()).map(([slug, pages], index) => ({
      slug,
      name: this.formatSectionName(slug),
      pages,
      isExpanded: index === 0
    }));
  }
  
  private formatSectionName(slug: string): string {
    // Identity function for now - converts kebab-case to Title Case
    return slug
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
